<template>
  <div>
    <div class="container-fluid">
      <div>
        <b-table
          show-empty
          bordered
          small
          stacked="md"
          head-variant="light"
          :items="taxes"
          :fields="fields"
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle" variant="yellow" />
            </div>
          </template>
          <template #cell(selected)="{ item }">
            <div class="d-flex justify-content-center">
              <b-form-checkbox
                :checked="item.appliesDefault == 1 ? true : false"
                @change="(val) => onRowSelected(val, item)"
              />
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["taxes"],
  data() {
    return {
      fields: [
        { key: "tps", label: "Tax name" },
        { key: "percent", label: "%" },
        "selected",
      ],
      itemsSelected: [],
      rowsSelected: [],
    };
  },
  computed: {},

  methods: {
    getSelectedItems(items) {
      this.rowsSelected = items;
      this.$emit("update-select-taxes", this.rowsSelected);
    },
    onRowSelected(val, item) {
      if (val) {
        this.itemsSelected.push(item);
      } else {
        const index = this.itemsSelected.indexOf(item);
        this.itemsSelected.splice(index, 1);
      }
      this.getSelectedItems([...this.itemsSelected]);
    },
  },
  created() {
    this.taxes.forEach((tax) => {
      if (tax.appliesDefault == 1) {
        this.onRowSelected(true, tax);
      }
    });
  },
  updated() {
    this.itemsSelected = [];
    let taxDefault = this.taxes.filter((tax) => tax.appliesDefault == 1);
    taxDefault.forEach((tax) => {
      this.onRowSelected(true, tax);
    });
  },
};
</script>

<style>
</style>